export default __webpack_public_path__ + "static/media/website pm.baa5d649.png";